import { render, staticRenderFns } from "./TheadTh.vue?vue&type=template&id=4277faf5"
import script from "./TheadTh.vue?vue&type=script&lang=js"
export * from "./TheadTh.vue?vue&type=script&lang=js"
import style0 from "./TheadTh.vue?vue&type=style&index=0&id=4277faf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports